import { render, staticRenderFns } from "./bot.vue?vue&type=template&id=557266da"
import script from "./bot.vue?vue&type=script&lang=js"
export * from "./bot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports